import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import UserCreateModalUI from './UserCreateModalUI.js'

class UserCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      accountId: this.props.account && this.props.account.accountId,
      // form events
      submitted: false,
      // form field
      firstName: '',
      firstNameError: null,
      lastName: '',
      lastNameError: null,
      address: '',
      addressError: null,
      email: '',
      emailError: null,
    }
  }

  render() {
    return (
      <UserCreateModalUI
        context={this.props.context}
        account={this.props.account}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        createMode={this.props.createMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelCreate}
        // form fields
        firstName={this.state.firstName}
        onFirstNameChange={(event) => this.setState({ firstName: event.target.value })}
        firstNameError={this.state.firstNameError}
        setFirstNameError={(error) => { this.setState({ firstNameError: error }) }}
        lastName={this.state.lastName}
        onLastNameChange={(event) => this.setState({ lastName: event.target.value })}
        lastNameError={this.state.lastNameError}
        setLastNameError={(error) => { this.setState({ lastNameError: error }) }}
        email={this.state.email}
        onEmailChange={(event) => this.setState({ email: event.target.value })}
        emailError={this.state.emailError}
        setEmailError={(error) => { this.setState({ emailError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (!this.props.account)
      return
    if (!prevProps.account || prevProps.account.accountId !== this.props.account.accountId)
      this.setState({accountId: this.props.account.accountId})
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.state.accountId}/users`,
      this.onSubmitCallback, {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelCreate()
        this.props.onRefreshClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
  }
}

export default withRouter(UserCreateModalSF)
